import { useTranslations } from 'hooks/useTranslations';
import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.mjs`;

interface PDFViewerProps {
  pdfUrl: string;
  width?: number | string;
  height?: number | string;
}

const PDFViewer = ({ pdfUrl, width = '100%', height }: PDFViewerProps) => {
  const { t } = useTranslations();
  const [numPages, setNumPages] = useState<number | null>(null);
  const [containerWidth, setContainerWidth] = useState<number>(0);

  const a4Ratio = 1.414;
  const calculatedHeight = height || `${containerWidth * a4Ratio}px`;

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  function onDocumentLoadError(error: Error) {
    console.error(error);
  }

  return (
    <div
      ref={(el) => {
        if (el) {
          setContainerWidth(el.offsetWidth);
        }
      }}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height:
          typeof calculatedHeight === 'number' ? `${calculatedHeight}px` : calculatedHeight,
        overflow: 'auto',
        border: '1px solid #ddd',
        borderRadius: '4px',
      }}
    >
      <Document
        file={pdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={<div style={{ padding: '20px' }}>{t('general.loading.label')}</div>}
        error={
          <div style={{ padding: '20px', color: 'red' }}>
            {t('general.loadaing.error.label')}
          </div>
        }
      >
        {Array.from(new Array(numPages), (_, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={containerWidth - 20}
            renderTextLayer={true}
            renderAnnotationLayer={true}
          />
        ))}
      </Document>
    </div>
  );
};

export default PDFViewer;
